import React, { FC } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { makeStyles } from '@mui/styles';
import { theme } from '../../styles';

export interface IClearAdornmentProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  show?: boolean;
}

export const ClearAdornment: FC<IClearAdornmentProps> = ({ onClick, show = true }) => {
  const classes = useStyles();

  return (
    <InputAdornment position="end">
      {show && (
        <IconButton size="small" className={classes.clearIcon} onClick={onClick}>
          <ClearIcon />
        </IconButton>
      )}
    </InputAdornment>
  );
};

const useStyles = makeStyles(() => {
  return {
    clearIcon: {
      color: theme.palette.grey[400],
      cursor: 'pointer',
    },
  };
});
